import React, { useState } from 'react';
import './Loader.css';
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import { Dialog } from '@material-ui/core';
import Lottie from 'lottie-react';
import SpinLoader from './loader.json';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  dialogLoader: {
    width: '100vmax',
    height: '100vh',
    transform: 'scale(1)',
    transition: 'transform 0.5s ease-in-out',
    boxShadow: 'none',
    backgroundColor: 'transparent',
    padding: '0 !important',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  
 
  '@media (max-width: 600px)': {
    dialogLoader: {
      // CSS styles specific to max-width 600px
      // For example:
      width: '100vw',
      height: '100vh',
      padding: 0,
      margin: 0,
      margin: '0 !important', // Override margin
      maxHeight: '100% !important', // Override max-height      
    },
  },
});

function Loader(isLoading) {

  const classes = useStyles();
  const [showLoader, setShowLoader] = useState(false);
  const handleLoaderOpen = () => {
    if(isLoading === true){
      setShowLoader(true);
    }
  }
  const handleLoaderClose = () => {
    if(isLoading === false){
      setShowLoader(false);
    }
  }
  return (
    //   <Stack sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'crimson'}}>
    //   <CircularProgress color="primary" size={30}/>
    // </Stack>
    <>
    <Dialog
      onClose={handleLoaderClose}
      open={handleLoaderOpen}
      classes={{
        paper: classes.dialogLoader,
      }}
      BackdropProps={{
        style: {
          backgroundColor: "rgba(8, 8, 8, 0.541)",
          backdropFilter: "blur(4px)",
        },
      }}
    >
      <div className='loader_wrap' style={{width: '120px', height: '120px'}}>
        <Lottie animationData={SpinLoader}/>
      </div>
    </Dialog>
    </>
  );
}

export default Loader;